module.exports = __webpack_public_path__ + "img/button1_fcbadfd3b.png";